import React, { useContext } from 'react'
import { ThreeDots } from 'react-bootstrap-icons';
import { RechercheContext } from '../Recherche';

function Pagination({ totalItems, itemsPerPage, currentPage }) {

    const provider = useContext(RechercheContext);
    const onPageChange = (page) => {
        provider.goToPage(page);
    }
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    //const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const before = currentPage - 1;
    const after = currentPage + 1;

    return (
        <div>
            <ul className="pagination">
                <li>
                    <button className={"me-1 " + (1 === currentPage ? 'btn btn-primary' : 'btn btn-secondary')} onClick={() => onPageChange(1)}>1</button>
                </li>
                {before - 1 > 1 && <li><ThreeDots className='fs-3 mx-2' /></li>}
                {before > 1 && <li><button className={'me-1 btn btn-secondary'} onClick={() => onPageChange(before)}>{before}</button></li>}
                {(before > 0 && currentPage != totalPages) && <li><button className={'me-1 btn btn-primary'} onClick={() => onPageChange(currentPage)}>{currentPage}</button></li>}
                {
                    after < totalPages && (
                        <li>
                            <button className={'me-1 btn btn-secondary'} onClick={() => onPageChange(after)}>{after}</button>
                        </li>
                    )
                }

                {
                    after + 1 < totalPages && (<li><ThreeDots className='fs-3 mx-2' /></li>)
                }
                <li>
                    <button className={"me-1 " + (totalPages === currentPage ? 'btn btn-primary' : 'btn btn-secondary')} onClick={() => onPageChange(totalPages)}>{totalPages}</button>
                </li>
            </ul>
        </div>
    )
}

export default Pagination